import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTheme } from "@inbody/core";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { HeaderIconButton } from "./HeaderIconButton.js";
function ThemeChangeSwitch({
  fontSize = "medium",
  size
}) {
  const { mode, toggleThemeMode } = useTheme();
  const handleToggleMode = useCallback(() => {
    toggleThemeMode();
  }, [toggleThemeMode]);
  const isDarkMode = mode === "dark";
  return /* @__PURE__ */ jsx(HeaderIconButton, { onClick: handleToggleMode, "aria-label": "toggle theme", children: isDarkMode ? /* @__PURE__ */ jsx(DarkModeIcon, { fontSize, sx: { width: size, height: size } }) : /* @__PURE__ */ jsx(LightModeIcon, { fontSize, sx: { width: size, height: size } }) });
}
export {
  ThemeChangeSwitch
};
